import React  from 'react';
function FruitsZakatTable({ result }) {
  return (
    <table >
      <thead>
        <tr>
          <th >Status</th>
          <th >Results</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Fruits and Crops Zakat Threshold</td>
          <td>{result.threshold} (kg)</td>
        </tr>
        <tr>
          <td>Amount of Zakat Obligatory to Be Paid (from Fruits)</td>
          <td>{result.fruitsZakatAmount} (kg)</td>
        </tr>
        <tr>
          <td>Amount of Zakat Obligatory to Be Paid (from Money)</td>
          <td>{result.moneyZakatAmount}</td>
        </tr>
      </tbody>
    </table>
  );
}
export default FruitsZakatTable;
